import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "drama-detail"
};
const _hoisted_2 = {
  class: "drama-detail-container"
};
const _hoisted_3 = {
  class: "drama-name"
};
const _hoisted_4 = {
  class: "drama-desc"
};
const _hoisted_5 = {
  key: 0,
  class: "drama-oddment"
};
const _hoisted_6 = {
  class: "avatar-container"
};
const _hoisted_7 = {
  class: "avatar-frame"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "avatar-container"
};
const _hoisted_10 = {
  class: "avatar-frame top_role"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "drama-intro"
};
import { ref, computed, onMounted } from 'vue';
import { ElCol, ElRow, ElDivider, ElIcon, ElImage, ElMessage } from 'element-plus';
import { ArrowLeftBold, CaretRight, PriceTag, Timer, Location, Clock, Odometer, Ticket, Reading, Film } from '@element-plus/icons-vue';
import { request } from '@/manager/net_manager';
import store from '@/store';
import router from "@/router";
import { getDifficultyDegree, inApostleType, isAdminType, placeholderImage } from '@/tools/utils';
import 'element-plus/es/components/statistic/style/css';
import DramaEditCard from "@/components/Drama/DramaEditCard.vue";
import MaskerLayer from "@/components/Basic/MaskerLayer.vue";
import DramaStatChart from '@/components/Drama/DramaStatChart.vue'; // pre-declaration

export default {
  __name: 'DramaDetail',
  props: {
    dramaId: {
      type: [Number, String, null],
      required: false,
      default: null
    }
  },

  setup(__props) {
    const props = __props; // refs

    const drama = ref(null);
    const dramaStat = ref({});
    const editMode = ref(false); // functions

    const getData = () => {
      let parameters = {
        'drama_id': props.dramaId
      };
      request('drama/get/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          drama.value = response.data;
          dramaStat.value = response.data.stats;
        }
      });
    };

    const removeDrama = () => {
      let parameters = {
        'drama_id': props.dramaId
      };
      request('drama/remove/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        ElMessage.success({
          message: '剧本已移除',
          duration: 1500
        });
        goBack();
      });
    }; // computed


    const userType = computed(() => {
      return store.state.user ? parseInt(store.state.user.user_type) : 4;
    }); // functions

    const goBack = () => {
      router.back();
    };

    const createStage = () => {
      router.push({
        name: 'stageGenerator',
        params: {
          drama_id: props.dramaId
        }
      });
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      return drama.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(ElRow), {
        class: "nav-bar"
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), {
          style: {
            "align-items": "center"
          },
          onClick: goBack
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElIcon), null, {
            default: _withCtx(() => [_createVNode(_unref(ArrowLeftBold))]),
            _: 1
          }), _cache[3] || (_cache[3] = _createElementVNode("text", {
            class: "left-nav-title"
          }, "回退", -1))]),
          _: 1
        }), _unref(inApostleType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElRow), {
          key: 0,
          style: {
            "gap": "8px"
          }
        }, {
          default: _withCtx(() => [_unref(isAdminType)(userType.value) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "alert",
            onClick: removeDrama
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode(" 删除剧本 ", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = $event => editMode.value = true)
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" 修改剧本 ", -1)]))]),
            _: 1
          }), _createVNode(_component_el_button, {
            onClick: createStage
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" 创建舞台 ", -1)]))]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_unref(ElCol), {
        style: {
          "width": "80%",
          "align-items": "center"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
          default: _withCtx(() => [_createElementVNode("text", _hoisted_3, _toDisplayString(drama.value.name), 1)]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          style: {
            "justify-content": "flex-start"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("text", _hoisted_4, _toDisplayString(drama.value.description), 1)]),
          _: 1
        }), _createVNode(_unref(ElRow), {
          style: {
            "justify-content": "flex-end"
          }
        }, {
          default: _withCtx(() => [drama.value.oddment ? (_openBlock(), _createElementBlock("text", _hoisted_5, "（" + _toDisplayString(drama.value.oddment) + "）", 1)) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_unref(ElDivider)), _createVNode(_unref(ElRow), {
        style: {
          "width": "80%",
          "align-items": "center"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElCol), {
          span: 13
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            class: "detail-row"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElIcon), {
              size: 14,
              style: {
                "margin-right": "0.5rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_unref(Reading))]),
              _: 1
            }), _createElementVNode("text", null, "来自： " + _toDisplayString(drama.value.creator_org ? `${drama.value.creator_org} / ` : '') + _toDisplayString(drama.value.creator) + " / " + _toDisplayString(drama.value.create_time), 1)]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "detail-row"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElIcon), {
              size: 14,
              style: {
                "margin-right": "0.5rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_unref(Film))]),
              _: 1
            }), _createElementVNode("text", null, "世界观： " + _toDisplayString(drama.value.world_outlook.name), 1), _createVNode(_unref(ElDivider), {
              direction: "vertical"
            }), _createVNode(_unref(ElIcon), {
              size: 14,
              style: {
                "margin-right": "0.5rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_unref(Ticket))]),
              _: 1
            }), _createElementVNode("text", null, "风格 ： " + _toDisplayString(drama.value.nature.desc ?? ''), 1), _createVNode(_unref(ElDivider), {
              direction: "vertical"
            }), _createVNode(_unref(ElIcon), {
              size: 14,
              style: {
                "margin-right": "0.5rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_unref(Odometer))]),
              _: 1
            }), _createElementVNode("text", null, "难度 ： " + _toDisplayString((drama.value.difficulty / 10).toFixed(1)) + " (" + _toDisplayString(_unref(getDifficultyDegree)(drama.value.difficulty)) + ") ", 1)]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "detail-row"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElIcon), {
              size: 14,
              style: {
                "margin-right": "0.5rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_unref(PriceTag))]),
              _: 1
            }), _createElementVNode("text", null, "剧本标签：" + _toDisplayString(drama.value.tendency), 1)]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            class: "detail-row"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ElIcon), {
              size: 14,
              style: {
                "margin-right": "0.5rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_unref(Timer))]),
              _: 1
            }), _createElementVNode("text", null, "预期长度：" + _toDisplayString(drama.value.construction_period), 1), _createVNode(_unref(ElDivider), {
              direction: "vertical"
            }), _createVNode(_unref(ElIcon), {
              size: 14,
              style: {
                "margin-right": "0.5rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_unref(Clock))]),
              _: 1
            }), _createElementVNode("text", null, "剧本年代：" + _toDisplayString(drama.value.era), 1), _createVNode(_unref(ElDivider), {
              direction: "vertical"
            }), _createVNode(_unref(ElIcon), {
              size: 14,
              style: {
                "margin-right": "0.5rem"
              }
            }, {
              default: _withCtx(() => [_createVNode(_unref(Location))]),
              _: 1
            }), _createElementVNode("text", null, "主要地点：" + _toDisplayString(drama.value.location), 1)]),
            _: 1
          })]),
          _: 1
        }), dramaStat.value ? (_openBlock(), _createBlock(_unref(ElCol), {
          key: 0,
          offset: 1,
          span: 10
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElRow), {
            style: {
              "align-items": "center",
              "justify-content": "flex-start"
            }
          }, {
            default: _withCtx(() => [_cache[9] || (_cache[9] = _createElementVNode("text", {
              style: {
                "margin-right": "5px"
              }
            }, "主力链接者", -1)), _createVNode(_unref(ElIcon), null, {
              default: _withCtx(() => [_createVNode(_unref(CaretRight))]),
              _: 1
            }), _createElementVNode("div", _hoisted_6, [_cache[7] || (_cache[7] = _createElementVNode("div", {
              class: "shadow-layer"
            }, null, -1)), _cache[8] || (_cache[8] = _createElementVNode("div", {
              class: "glow-effect"
            }, null, -1)), _createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
              src: dramaStat.value?.top_anchor?.avatar ?? _unref(placeholderImage),
              alt: "Avatar",
              class: "avatar-image"
            }, null, 8, _hoisted_8)])]), _createElementVNode("text", null, [_createElementVNode("b", null, _toDisplayString(dramaStat.value?.top_anchor?.name), 1), _createTextVNode("（" + _toDisplayString(dramaStat.value?.top_anchor?.count) + "次）", 1)])]),
            _: 1
          }), _createVNode(_unref(ElRow), {
            style: {
              "align-items": "center",
              "justify-content": "flex-start",
              "margin-top": "0.5rem"
            }
          }, {
            default: _withCtx(() => [_cache[12] || (_cache[12] = _createElementVNode("text", {
              style: {
                "margin-right": "5px"
              }
            }, "最佳选中者", -1)), _createVNode(_unref(ElIcon), null, {
              default: _withCtx(() => [_createVNode(_unref(CaretRight))]),
              _: 1
            }), _createElementVNode("div", _hoisted_9, [_cache[10] || (_cache[10] = _createElementVNode("div", {
              class: "shadow-layer"
            }, null, -1)), _cache[11] || (_cache[11] = _createElementVNode("div", {
              class: "glow-effect"
            }, null, -1)), _createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
              src: dramaStat.value?.top_role?.avatar ?? _unref(placeholderImage),
              alt: "Avatar",
              class: "avatar-image"
            }, null, 8, _hoisted_11)])]), _createElementVNode("text", null, [_createElementVNode("b", null, _toDisplayString(dramaStat.value?.top_role?.name), 1), _createTextVNode("（挑战分" + _toDisplayString(dramaStat.value?.top_role?.score) + "）", 1)])]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_unref(ElDivider)), _createElementVNode("div", _hoisted_12, [_createVNode(_unref(ElRow), {
        style: {
          "margin-top": "1.6rem"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElCol), {
          style: {
            "position": "relative"
          }
        }, {
          default: _withCtx(() => [_createVNode(_unref(ElImage), {
            src: drama.value?.image_url ?? '',
            fit: "cover",
            draggable: false
          }, null, 8, ["src"]), _createVNode(DramaStatChart, {
            "chart-data": dramaStat.value
          }, null, 8, ["chart-data"])]),
          _: 1
        })]),
        _: 1
      })])]), editMode.value ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 0,
        onClose: _cache[2] || (_cache[2] = $event => editMode.value = false)
      }, {
        default: _withCtx(() => [_createVNode(DramaEditCard, {
          "drama-id": drama.value?.id,
          onReload: getData,
          onClose: _cache[1] || (_cache[1] = $event => editMode.value = false)
        }, null, 8, ["drama-id"])]),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
    };
  }

};